import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { POST_LOGIN_REDIRECT_PATH } from "@/features/auth/constants/auth.constants";
import { guardLegalConsents } from "@/features/legal/utils/legal-consent-gate";

export const Route = createFileRoute("/onboarding")({
  staticData: { sitemap: false },
  // Browser only, like everything behind the login: the session cookie is not on a server render's
  // request, so with SSR on every reload here bounced to /login and lost the person's place.
  ssr: false,
  component: OnboardingLayout,
  validateSearch: z.object({
    redirect: z.string().optional(),
    invitation_token: z.string().optional(),
  }),
  beforeLoad: async ({ search, location }) => {
    const { data } = await sdk.users.me.$get.send();

    if (!data) {
      const onboardingPath =
        location.pathname + location.searchStr ||
        (search.redirect ? `/onboarding?redirect=${encodeURIComponent(search.redirect)}` : "/onboarding");
      throw redirect({ to: "/login", search: { redirect: onboardingPath } });
    }

    await guardLegalConsents({ userId: data.user.id, location });

    const hasOrganization = Boolean(data.organizationId) && (data.organizations?.length ?? 0) > 0;
    if (hasOrganization) {
      throw redirect({ to: search.redirect ?? POST_LOGIN_REDIRECT_PATH });
    }

    return { user: data };
  },
});

function OnboardingLayout() {
  return (
    <div className="min-h-svh bg-background">
      <Outlet />
    </div>
  );
}
